export default __webpack_public_path__ + "static/media/usdc.06d3a578.svg";